export default {
  title: {
    add: 'Adaugă Script',
    update: 'Actualizează Script',
  },
  form: {
    strategy: {
      label: 'Strategie',
      placeholder: 'Selectați Strategia',
    },
    source: {
      label: 'Sursă (src)',
      placeholder: 'Introduceți Sursa',
    },
    async: {
      label: 'Async',
      placeholder: 'Selectați Async',
    },
    content: {
      label: 'Conținut',
      placeholder: 'Introduceți Conținut',
    },
  },
  alert: {
    use_case: 'Caz de utilizare',
  },
  buttons: {
    save: 'Salvați',
  },
};
